// extracted by mini-css-extract-plugin
export default {"menuIcon":"AdminMobileMenuBar_menuIcon__xqM6G","hamIcon":"AdminMobileMenuBar_hamIcon__Ep4YQ","fixed":"AdminMobileMenuBar_fixed__lud7K"};